// Class: haxe.xml._Fast.HasNodeAccess

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;

// Constructor

var HasNodeAccess = function(x) {
	this.__x = x;
}

// Meta

HasNodeAccess.__name__ = ["haxe","xml","_Fast","HasNodeAccess"];
HasNodeAccess.prototype = {
	resolve: function(name) {
		return this.__x.elementsNamed(name).hasNext();
	}
};
HasNodeAccess.prototype.__class__ = HasNodeAccess.prototype.constructor = $hxClasses["haxe.xml._Fast.HasNodeAccess"] = HasNodeAccess;

// Init



// Statics




// Export

exports.default = HasNodeAccess;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/haxe/xml/_Fast/HasNodeAccess.js
// module id = 314
// module chunks = 0